import { SHEET_NAME as PENALTY_OR_FINE_SHEET } from "./penaltyOrFineSheet";
import { SHEET_NAME as SETTLEMENT_SHEET } from "./settlementSheet";
import { SHEET_NAME as COMPOUNDING_FEE_SHEET } from "./compoundingFeeSheet";
import { SHEET_NAME as IMPRISONMENT_SHEET } from "./imprisonmentSheet";
import { SHEET_NAME as PUNISHMENT_SHEET } from "./punishmentSheet";
import { SHEET_NAME as APPEAL_OR_REVISION_CASE_SHEET } from "./appealOrRevisionCaseSheet";
import { SHEET_NAME as PROGRAMMES_FOR_VALUE_CHAIN_SHEET } from "./programmesForValueChainSheet";
import { getFinancialYearLabels } from "../../brsrFinancialYearLabels";
import {
  BODY_FONT,
  HEADER_FILL,
  HEADER_FONT_11,
  TITLE_FONT,
  hideColumnsAfter,
  hideRowsThrough,
  LINK_FONT,
  NA_FILL,
  THIN_BLACK,
  VALUE_FILL,
} from "./detailSheetCommon";

const CALC_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFBEBEBE" },
};

const COL_D = 4;
const COL_E = 5;
const COL_F = 6;
const COL_G = 7;
const COL_H = 8;
const COL_I = 9;
const COL_END = COL_I;

const FIRST_ROW = 8;

const LABELS = {
  sectionC: "SECTION C: PRINCIPLE WISE PERFORMANCE DISCLOSURE",
  intro:
    "This section is aimed at helping entities demonstrate their performance in integrating the Principles and Core Elements with key processes and decisions. The information sought is categorized as \u201cEssential\u201d and \u201cLeadership\u201d. While the essential indicators are expected to be disclosed by every entity that is mandated to file this report, the leadership indicators may be voluntarily disclosed by entities which aspire to progress to a higher level in their quest to be socially, environmentally and ethically responsible.",
  principleTitle:
    "PRINCIPLE 1 Businesses should conduct and govern themselves with integrity, and in a manner that is Ethical, Transparent and Accountable.",
  essential: "Essential Indicators",
  leadership: "Leadership Indicators",
  q1: "1. Percentage coverage by training and awareness programmes on any of the Principles during the financial year:",
  q2:
    "2. Details of fines / penalties /punishment/ award/ compounding fees/ settlement amount paid in proceedings (by the entity or by directors / KMPs) with regulators/ law enforcement agencies/ judicial institutions, in the financial year, in the following format (Note: the entity shall make disclosures on the basis of materiality as specified in Regulation 30 of SEBI (Listing Obligations and Disclosure Obligations) Regulations, 2015 and as disclosed on the entity\u2019s website):",
  monetary: "Monetary",
  nonMonetary: "Non- Monetary",
  q3:
    "3. Of the instances disclosed in Question 2 above, details of the Appeal/ Revision preferred in cases where monetary or non-monetary action has been appealed",
  q4: "4. Does the entity have anti-corruption or anti-bribery policy?",
  q4Details: "If Yes, provide details in brief",
  q4Link: "Provide a web-link if the entity has anti-corruption or anti-bribery policy",
  q5:
    "5. Number of Directors/KMPs/employees/workers against whom disciplinary action was taken by any law enforcement agency for the charges of bribery/ corruption:",
  q6: "6. Details of complaints with regard to conflict of interest:",
  q7:
    "7. Provide details of any corrective action taken or underway on issues related to fines / penalties / action taken by regulators/ law enforcement agencies/ judicial institutions, on cases of corruption and conflicts of interest.",
  q8: "8. Number of days of accounts payables",
  q9:
    "9. Open-ness of business - Provide details of concentration of purchases and sales with trading houses, dealers, and related parties along-with loans and advances & investments, with related parties, in the following format",
  leadershipQ1:
    "1. Awareness programmes conducted for value chain partners on any of the Principles during the financial year",
  leadershipQ2:
    "2. Does the entity have processes in place to avoid/ manage conflict of interests involving members of the Board?",
  leadershipQ2Details: "If Yes, provide details of the same.",
  notes: "Notes",
};

const LINE_HEIGHT = 15;
const MIN_ROW_HEIGHT = 18;

const THIN = { style: "thin", color: { argb: "FF000000" } };
const MEDIUM = { style: "medium", color: { argb: "FF000000" } };

const REF_ROW_HEIGHTS = {
  8: 30,
  9: 45,
  10: 18.5,
  11: 20.15,
  13: 50.15,
  14: 101.5,
  15: 29,
  16: 43.5,
  17: 43.5,
  18: 31.5,
  27: 30,
  28: 30,
  29: 87,
  39: 29,
  40: 29,
  41: 29.25,
  42: 15,
  43: 15,
  44: 15,
  45: 15,
  46: 15,
  47: 30,
  49: 29,
  51: 29,
  52: 29,
  54: 30,
  55: 43.5,
  59: 29,
  60: 29,
  62: 30,
  63: 45,
  65: 29,
  67: 45,
  68: 30,
  70: 29,
  71: 29,
  73: 45,
  76: 29,
  77: 20.15,
  78: 30,
  79: 30,
  80: 30,
  81: 33,
};

const BORDER_PATTERNS = {
  sectionBand: ["mm--", "m---", "m---", "m---", "m---", "m--m"],
  introRow: ["mmt-", "m-t-", "m-t-", "m-t-", "m-t-", "m-tm"],
  principleBand: ["tmt-", "t-t-", "t-t-", "t-t-", "t-t-", "t-tm"],
  subtitleBand: ["tm--", "t---", "t---", "t---", "t---", "t--m"],
  questionRow: ["mmt-", "m-t-", "m-t-", "m-t-", "m-t-", "m-tm"],
  tableHeader: ["-mtt", "-ttt", "-ttt", "-ttt", "----", "---m"],
  trainingDataA: ["tmtt", "tttt", "tttt", "tttt", "----", "---m"],
  trainingDataB: ["tmtt", "tttt", "-t-t", "tttt", "----", "---m"],
  trainingDataC: ["tmtt", "tttt", "tt-t", "tttt", "----", "---m"],
  trainingDataD: ["tm-t", "tttt", "tttt", "tttt", "----", "---m"],
  q2Row: ["tmtt", "tttt", "tttt", "tttt", "tttt", "tttm"],
  subBand: ["-mtt", "-ttt", "----", "----", "----", "---m"],
  subBandWhite: ["-mtt", "-ttt", "----", "----", "----", "---m"],
  fineData: ["tmtt", "tttt", "----", "----", "----", "---m"],
  fineDataEnd: ["tmtt", "tttt", "--t-", "--t-", "--t-", "--tm"],
  q3Row: ["tmt-", "t-t-", "--t-", "--t-", "----", "-t-m"],
  q4Row: ["tmt-", "t-t-", "t-tt", "tt-t", "tttt", "tt-m"],
  q4Details: ["tmt-", "t-t-", "t-t-", "tttt", "t---", "---m"],
  q4Link: ["tmt-", "t-t-", "t-tt", "-ttt", "-tt-", "---m"],
  fyHeader: ["-mtt", "-ttt", "-ttt", "----", "----", "---m"],
  tableData: ["tmtt", "tttt", "tttt", "----", "----", "---m"],
  tableDataEnd: ["tm-t", "tttt", "tttt", "----", "----", "---m"],
  conflictFy: ["tmtt", "tttt", "tttt", "ttt-", "t-t-", "t-tm"],
  conflictSub: ["tmtt", "tttt", "tttt", "tttt", "tttt", "tttm"],
  conflictData: ["tmtt", "tttt", "tttt", "tttt", "tttt", "tttm"],
  q7Row: ["tmt-", "t-t-", "t-t-", "t-t-", "t-tt", "tttm"],
  q8Label: ["tmtt", "ttt-", "tttt", "----", "----", "---m"],
  apLabel: ["tmtt", "-t--", "tt-t", "----", "----", "---m"],
  apFormula: ["tm--", "tttt", "tttt", "----", "----", "---m"],
  q9Intro: ["tmtt", "-ttt", "-ttt", "tttt", "----", "---m"],
  opennessHeader: ["tmtt", "tttt", "-ttt", "-ttt", "----", "---m"],
  opennessFirst: ["tm-t", "tttt", "tttt", "t-tt", "----", "---m"],
  opennessMid: ["-m-t", "tttt", "tt-t", "t--t", "----", "---m"],
  opennessPct: ["-mtt", "ttt-", "tttt", "tttt", "----", "---m"],
  opennessB: ["-m-t", "tttt", "-ttt", "--tt", "----", "---m"],
  opennessCFirst: ["-m-t", "tttt", "tttt", "t-tt", "----", "---m"],
  opennessCLast: ["-mtt", "ttt-", "tttt", "tttt", "----", "---m"],
  leadershipBand: ["tmt-", "t-t-", "--t-", "--t-", "t-t-", "t-tm"],
  leadershipQ1: ["-mt-", "--t-", "--t-", "--t-", "-ttt", "---m"],
  leadershipQ2: ["tmt-", "t-t-", "t-t-", "t-tt", "-tt-", "tttm"],
  leadershipDetails: ["tmt-", "t-t-", "t-t-", "t-tt", "tt-t", "---m"],
  notesRow: ["tmmt", "ttmt", "ttm-", "t-m-", "t-m-", "t-mm"],
};

function parseBorderSpec(spec) {
  const map = { t: THIN, m: MEDIUM };
  return {
    top: spec[0] !== "-" ? map[spec[0]] : undefined,
    left: spec[1] !== "-" ? map[spec[1]] : undefined,
    bottom: spec[2] !== "-" ? map[spec[2]] : undefined,
    right: spec[3] !== "-" ? map[spec[3]] : undefined,
  };
}

function applyRowBorders(ws, row, patternKey) {
  const pattern = BORDER_PATTERNS[patternKey];
  if (!pattern) return;
  pattern.forEach((spec, index) => {
    ws.getCell(row, COL_D + index).border = parseBorderSpec(spec);
  });
}

function finishRow(ws, row, patternKey, height) {
  applyRowBorders(ws, row, patternKey);
  if (height != null) ws.getRow(row).height = height;
  else if (REF_ROW_HEIGHTS[row] != null) ws.getRow(row).height = REF_ROW_HEIGHTS[row];
}

function applySectionFill(ws, row) {
  for (let col = COL_D; col <= COL_END; col += 1) {
    ws.getCell(row, col).fill = HEADER_FILL;
  }
}

function applyGreyBandFill(ws, row, startCol = COL_D, endCol = COL_END) {
  for (let col = startCol; col <= endCol; col += 1) {
    ws.getCell(row, col).fill = NA_FILL;
  }
}

function applyGreyUnusedCols(ws, row, startCol = COL_H) {
  for (let col = startCol; col <= COL_I; col += 1) {
    ws.getCell(row, col).fill = NA_FILL;
  }
}

function applyGreyFineCols(ws, row) {
  for (let col = COL_F; col <= COL_I; col += 1) {
    ws.getCell(row, col).fill = NA_FILL;
  }
}

function applyQ4LabelFill(ws, row) {
  [COL_E, COL_F].forEach((col) => {
    ws.getCell(row, col).fill = VALUE_FILL;
  });
}

function setCellFill(ws, row, col, fill) {
  ws.getCell(row, col).fill = fill;
}

function applyMergedLabelFills(ws, row, startCol, endCol, fill = VALUE_FILL) {
  for (let col = startCol; col <= endCol; col += 1) {
    setCellFill(ws, row, col, fill);
  }
}

function boldColumns(ws, row, startCol, endCol) {
  for (let col = startCol; col <= endCol; col += 1) {
    const cell = ws.getCell(row, col);
    cell.font = { ...(cell.font || BODY_FONT), bold: true };
  }
}

function clearFill(ws, row, cols) {
  cols.forEach((col) => {
    ws.getCell(row, col).fill = undefined;
  });
}

function estimateRowHeight(text, colWidth, minHeight = MIN_ROW_HEIGHT) {
  const str = String(text ?? "");
  if (!str.trim()) return minHeight;
  const charsPerLine = Math.max(8, Math.floor(colWidth * 0.85));
  const lineCount = str.split(/\r?\n/).reduce(
    (total, part) => total + Math.max(1, Math.ceil(part.length / charsPerLine)),
    0
  );
  return Math.max(minHeight, lineCount * LINE_HEIGHT + 8);
}

function setAutoRowHeight(ws, row, parts) {
  ws.getRow(row).height = parts.reduce(
    (max, { text, width }) => Math.max(max, estimateRowHeight(text, width)),
    MIN_ROW_HEIGHT
  );
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  if (options.formula) {
    cell.value = { formula: options.formula };
  } else if (options.link) {
    cell.value = { text: value || "Add Details", hyperlink: options.link };
    cell.font = LINK_FONT;
  } else {
    cell.value = value;
    cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  }
  if (options.bordered !== false) {
    cell.border = options.border ?? THIN_BLACK;
  }
  cell.alignment = {
    horizontal: options.align ?? (options.link ? "center" : "left"),
    vertical: options.vertical || "middle",
    wrapText: options.wrapText !== false,
  };
  if (options.fill) cell.fill = options.fill;
}

function applyOuterMergeBorder(ws, row, patternKey) {
  const pattern = BORDER_PATTERNS[patternKey];
  if (!pattern) return;
  const left = parseBorderSpec(pattern[0]);
  const right = parseBorderSpec(pattern[pattern.length - 1]);
  ws.getCell(row, COL_D).border = {
    top: left.top,
    left: left.left,
    bottom: right.bottom,
    right: right.right,
  };
}

function applyPartialMergeBorder(ws, row, startCol, endCol, patternKey) {
  const pattern = BORDER_PATTERNS[patternKey];
  if (!pattern) return;
  const left = parseBorderSpec(pattern[startCol - COL_D]);
  const right = parseBorderSpec(pattern[endCol - COL_D]);
  ws.getCell(row, startCol).border = {
    top: left.top,
    left: left.left,
    bottom: right.bottom,
    right: right.right,
  };
}

function mergeRow(ws, row, startCol, endCol, value, options = {}) {
  setCell(ws, row, startCol, value, { ...options, bordered: false });
  for (let col = startCol + 1; col <= endCol; col += 1) {
    if (options.fill) ws.getCell(row, col).fill = options.fill;
  }
  if (startCol < endCol) ws.mergeCells(row, startCol, row, endCol);
  if (options.borderPattern) {
    if (startCol === COL_D && endCol === COL_END) {
      applyOuterMergeBorder(ws, row, options.borderPattern);
    } else {
      applyPartialMergeBorder(ws, row, startCol, endCol, options.borderPattern);
    }
  }
}

function addSectionBand(ws, row, title, height = 30) {
  finishRow(ws, row, "sectionBand", height);
  mergeRow(ws, row, COL_D, COL_END, title, {
    bold: true,
    align: "center",
    bordered: false,
    borderPattern: "sectionBand",
  });
  applySectionFill(ws, row);
  return row + 1;
}

function addSubtitleBand(ws, row, title, patternKey = "subtitleBand", { bold = false } = {}) {
  finishRow(ws, row, patternKey);
  mergeRow(ws, row, COL_D, COL_END, title, {
    align: "center",
    bold,
    bordered: false,
    borderPattern: patternKey,
  });
  if (bold) boldColumns(ws, row, COL_D, COL_END);
  applyGreyBandFill(ws, row);
  return row + 1;
}

function addPrincipleBand(ws, row, title, height = 18.5) {
  finishRow(ws, row, "principleBand", height);
  mergeRow(ws, row, COL_D, COL_END, title, {
    font: TITLE_FONT,
    bold: true,
    align: "center",
    bordered: false,
    borderPattern: "principleBand",
  });
  applySectionFill(ws, row);
  return row + 1;
}

function addFullWidthRow(ws, row, text, options = {}) {
  const borderPattern = options.borderPattern || "questionRow";
  if (!options.skipFinish) {
    finishRow(ws, row, borderPattern);
  }
  mergeRow(ws, row, COL_D, COL_END, text, {
    align: "left",
    vertical: "top",
    bold: options.bold,
    fill: options.fill,
    bordered: false,
    borderPattern: options.skipFinish ? undefined : borderPattern,
  });
  if (!options.fixedHeight && !options.skipAutoHeight) {
    setAutoRowHeight(ws, row, [{ text, width: 90 }]);
    if (REF_ROW_HEIGHTS[row] != null) ws.getRow(row).height = REF_ROW_HEIGHTS[row];
  }
  return row + 1;
}

function addDetailLink(ws, row, col, sheetName, targetCell) {
  setCell(ws, row, col, "Add Details", {
    align: "center",
    link: `#'${sheetName}'!${targetCell}`,
    bordered: false,
  });
}

function setGreyCell(ws, row, col) {
  setCell(ws, row, col, "", { fill: NA_FILL, bordered: false });
}

function safeText(value, fallback = "") {
  if (value === null || value === undefined || value === "") return fallback;
  if (Array.isArray(value)) return value.length ? value.join(", ") : fallback;
  if (typeof value === "object") return fallback;
  return String(value);
}

function toYesNo(value) {
  if (value === true || value === "true" || value === "yes" || value === "Yes") return "Yes";
  if (value === false || value === "false" || value === "no" || value === "No") return "No";
  return "";
}

function getNumberOrNA(value) {
  return value === 0 ? "0" : safeText(value, "");
}

function topicsText(value) {
  if (Array.isArray(value)) {
    const filtered = value.filter((item) => String(item).trim().toLowerCase() !== "select all");
    return filtered.length ? filtered.join(", ") : "";
  }
  return safeText(value);
}

function formatCoverageRatio(value) {
  if (value === null || value === undefined || value === "") return "";
  const str = String(value).replace("%", "").trim();
  const num = Number(str);
  if (Number.isNaN(num)) return str;
  if (num > 1) return (num / 100).toFixed(2).replace(/\.?0+$/, "") || "0";
  return String(num);
}

function formatOpennessValue(value) {
  if (value === null || value === undefined || value === "") return "";
  const str = String(value).replace("%", "").trim();
  const num = Number(str);
  if (Number.isNaN(num)) return str;
  return String(num);
}

function rptValue(rpt, section, key, yearKey) {
  return formatOpennessValue(rpt?.[section]?.[key]?.[yearKey]);
}

function ratioFormula(currentCol, rowNum, rowDenom) {
  const c = String.fromCharCode(64 + currentCol);
  return `IF(AND(${c}${rowNum}="",${c}${rowDenom}=""),"",IFERROR(ROUND(${c}${rowNum}/${c}${rowDenom},4),0))`;
}

function accountsPayablesFormula(col, rowNum, rowDenom) {
  const c = String.fromCharCode(64 + col);
  return `IF(OR(${c}${rowNum}<0,${c}${rowDenom}<0),0,IF(COUNT(${c}${rowNum}:${c}${rowDenom})=0,"",IFERROR(ROUND(${c}${rowNum}/${c}${rowDenom},2),0)))`;
}

function setDataCell(ws, row, col, value, align = "center") {
  setCell(ws, row, col, getNumberOrNA(value), { align, fill: VALUE_FILL, bordered: false });
}

function setFormulaCell(ws, row, col, formula) {
  setCell(ws, row, col, "", { formula, fill: CALC_FILL, align: "center", bordered: false });
}

/** Grey calculated cells (formula or precomputed value). */
function setCalcDataOrFormula(ws, row, col, value, formula) {
  if (value !== "" && value != null) {
    setCell(ws, row, col, getNumberOrNA(value), {
      align: "center",
      fill: CALC_FILL,
      bordered: false,
    });
  } else {
    setFormulaCell(ws, row, col, formula);
  }
}

function setupPrinciple1Sheet(ws) {
  const widths = {
    A: 9.1796875,
    B: 9.1796875,
    C: 9.1796875,
    D: 50.54296875,
    E: 36.1796875,
    F: 45.7265625,
    G: 35.7265625,
    H: 24.1796875,
    I: 31.26953125,
    J: 9.1796875,
    K: 9.1796875,
    L: 9.1796875,
  };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });
  ws.getColumn("A").hidden = true;
  ws.getColumn("B").hidden = true;
  // Visible through L; hide M → XFD.
  hideColumnsAfter(ws, 12);
  hideRowsThrough(ws, 5);

  ws.views = [
    {
      showGridLines: false,
      state: "frozen",
      ySplit: 8,
      topLeftCell: "A20",
      zoomScale: 80,
      zoomScaleNormal: 80,
    },
  ];
}

function addTrainingTable(ws, row, training) {
  row = addFullWidthRow(ws, row, LABELS.q1, { skipAutoHeight: true });

  setCell(ws, row, COL_D, "Segment", { align: "center", bordered: false, fill: NA_FILL });
  setCell(ws, row, COL_E, "Total number of training and awareness programmes held", {
    align: "center",
    bordered: false,
    fill: NA_FILL,
  });
  setCell(ws, row, COL_F, "Topics/principles covered under the training and its impact", {
    align: "center",
    bordered: false,
    fill: NA_FILL,
  });
  setCell(ws, row, COL_G, "%age of persons in respective category covered by the awareness programmes", {
    align: "center",
    bordered: false,
    fill: NA_FILL,
  });
  applyGreyUnusedCols(ws, row);
  finishRow(ws, row, "tableHeader", 50.15);
  row += 1;

  const segments = [
    ["boardOfDirectors", "Board of Directors", "trainingDataA"],
    ["keyManagementPersonnel", "Key Managerial Personnel", "trainingDataB"],
    ["employeesOtherThanBoDAndKMPs", "Employees other than BoD and KMPs", "trainingDataC"],
    ["workers", "Workers", "trainingDataD"],
  ];

  segments.forEach(([key, label, borderPattern]) => {
    const item = training?.[key] || {};
    setCell(ws, row, COL_D, label, { align: "left", vertical: "top", bordered: false });
    setDataCell(ws, row, COL_E, item.awarenessProgramHeld ?? item.totalProgrammesHeld);
    setCell(ws, row, COL_F, topicsText(item.principleUnderTraining), {
      align: "left",
      vertical: "top",
      fill: VALUE_FILL,
      bordered: false,
    });
    setDataCell(
      ws,
      row,
      COL_G,
      formatCoverageRatio(item.categoryCoveredPercentage ?? item.percentageCovered)
    );
    finishRow(ws, row, borderPattern);
    applyGreyUnusedCols(ws, row);
    if (!REF_ROW_HEIGHTS[row]) {
      setAutoRowHeight(ws, row, [
        { text: label, width: 22 },
        { text: topicsText(item.principleUnderTraining), width: 30 },
      ]);
    }
    row += 1;
  });

  return row;
}

function addFineRows(ws, row) {
  row = addFullWidthRow(ws, row, LABELS.q2, { borderPattern: "q2Row", fixedHeight: true });
  ws.getRow(row - 1).height = 31.5;

  finishRow(ws, row, "subBand");
  mergeRow(ws, row, COL_D, COL_E, LABELS.monetary, {
    bold: true,
    align: "center",
    bordered: false,
  });
  setCellFill(ws, row, COL_E, VALUE_FILL);
  applyGreyFineCols(ws, row);
  boldColumns(ws, row, COL_F, COL_I);
  row += 1;

  const monetaryRows = [
    ["Penalty/ Fine", PENALTY_OR_FINE_SHEET, "D12"],
    ["Settlement", SETTLEMENT_SHEET, "D12"],
    ["Compounding fee", COMPOUNDING_FEE_SHEET, "D12"],
  ];
  monetaryRows.forEach(([label, sheet, target]) => {
    setCell(ws, row, COL_D, label, { align: "left", bordered: false, bold: true });
    addDetailLink(ws, row, COL_E, sheet, target);
    boldColumns(ws, row, COL_F, COL_H);
    // Compounding fee (and other monetary rows) have no bottom border on F–I.
    finishRow(ws, row, "fineData");
    applyGreyFineCols(ws, row);
    row += 1;
  });

  finishRow(ws, row, "fineData");
  mergeRow(ws, row, COL_D, COL_E, LABELS.nonMonetary, {
    bold: true,
    align: "center",
    bordered: false,
  });
  setCellFill(ws, row, COL_E, VALUE_FILL);
  applyGreyFineCols(ws, row);
  boldColumns(ws, row, COL_F, COL_I);
  row += 1;

  const nonMonetaryRows = [
    ["Imprisonment", IMPRISONMENT_SHEET, "D12"],
    ["Punishment", PUNISHMENT_SHEET, "D12"],
  ];
  nonMonetaryRows.forEach(([label, sheet, target], idx) => {
    setCell(ws, row, COL_D, label, { align: "left", bordered: false, bold: true });
    addDetailLink(ws, row, COL_E, sheet, target);
    boldColumns(ws, row, COL_F, COL_H);
    // Only the last non-monetary row (Punishment) gets F–I bottom borders.
    finishRow(ws, row, idx === nonMonetaryRows.length - 1 ? "fineDataEnd" : "fineData");
    applyGreyFineCols(ws, row);
    row += 1;
  });

  return row;
}

function addDisciplinaryTable(ws, row, essential, fyCurrent, fyPrevious) {
  row = addFullWidthRow(ws, row, LABELS.q5, { skipAutoHeight: true });

  setCell(ws, row, COL_D, "", { bordered: false });
  setCell(ws, row, COL_E, fyCurrent, { bold: true, align: "center", bordered: false });
  setCell(ws, row, COL_F, fyPrevious, { bold: true, align: "center", bordered: false });
  finishRow(ws, row, "fyHeader");
  applyGreyUnusedCols(ws, row, COL_G);
  row += 1;

  const segments = [
    ["boardOfDirectors", "Directors"],
    ["keyManagementPersonnel", "KMPs"],
    ["employeesOtherThanBoDAndKMPs", "Employees"],
    ["workers", "Workers"],
  ];

  segments.forEach(([key, label], idx) => {
    const obj = essential?.disciplinaryActions?.[key];
    setCell(ws, row, COL_D, label, { align: "left", bordered: false });
    setDataCell(ws, row, COL_E, obj?.currentYear);
    setDataCell(ws, row, COL_F, obj?.previousYear);
    finishRow(ws, row, idx === segments.length - 1 ? "tableDataEnd" : "tableData");
    applyGreyUnusedCols(ws, row, COL_G);
    row += 1;
  });

  return row;
}

function addConflictTable(ws, row, essential, fyCurrent, fyPrevious) {
  row = addFullWidthRow(ws, row, LABELS.q6, { skipAutoHeight: true });

  const headerRow = row;
  setCell(ws, row, COL_D, "", { bordered: false });
  finishRow(ws, row, "conflictFy");
  mergeRow(ws, row, COL_E, COL_F, fyCurrent, { bold: true, align: "center", bordered: false });
  mergeRow(ws, row, COL_G, COL_I, fyPrevious, { bold: true, align: "center", bordered: false });
  row += 1;

  finishRow(ws, row, "conflictSub");
  setCell(ws, row, COL_E, "Number", { bold: true, align: "center", bordered: false });
  setCell(ws, row, COL_F, "Remarks", { bold: true, align: "center", fill: VALUE_FILL, bordered: false });
  setCell(ws, row, COL_G, "Number", { bold: true, align: "center", bordered: false });
  mergeRow(ws, row, COL_H, COL_I, "Remarks", {
    bold: true,
    align: "center",
    bordered: false,
  });
  setCellFill(ws, row, COL_H, VALUE_FILL);
  clearMergedSlaveFill(ws, row, COL_I);
  ws.mergeCells(headerRow, COL_D, row, COL_D);
  row += 1;

  const conflict = essential?.conflictOfInterestComplaints || {};
  const rows = [
    ["directors", "Directors"],
    ["keyManagement", "KMPs"],
  ];

  rows.forEach(([key, label]) => {
    const labelText = `Number of complaints received in relation to issues of Conflict of Interest of the ${label}`;
    setCell(ws, row, COL_D, labelText, { align: "left", vertical: "top", bordered: false });
    setDataCell(ws, row, COL_E, conflict?.currentFinancialYear?.[key]?.numberOfComplaints);
    setCell(ws, row, COL_F, safeText(conflict?.currentFinancialYear?.[key]?.remarks, "NA"), {
      align: "left",
      fill: VALUE_FILL,
      bordered: false,
    });
    setDataCell(ws, row, COL_G, conflict?.previousFinancialYear?.[key]?.numberOfComplaints);
    finishRow(ws, row, "conflictData");
    mergeRow(
      ws,
      row,
      COL_H,
      COL_I,
      safeText(conflict?.previousFinancialYear?.[key]?.remarks, "NA"),
      { align: "left", bordered: false }
    );
    setCellFill(ws, row, COL_F, VALUE_FILL);
    setCellFill(ws, row, COL_H, VALUE_FILL);
    clearMergedSlaveFill(ws, row, COL_I);
    if (!REF_ROW_HEIGHTS[row]) {
      setAutoRowHeight(ws, row, [{ text: labelText, width: 22 }]);
    }
    row += 1;
  });

  return row;
}

function addAccountsPayablesTable(ws, row, essential, fyCurrent, fyPrevious) {
  finishRow(ws, row, "q8Label");
  mergeRow(ws, row, COL_D, COL_F, LABELS.q8, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "q8Label",
  });
  applyGreyBandFill(ws, row, COL_G, COL_I);
  row += 1;

  setCell(ws, row, COL_D, "", { bordered: false });
  setCell(ws, row, COL_E, fyCurrent, { bold: true, align: "center", bordered: false });
  setCell(ws, row, COL_F, fyPrevious, { bold: true, align: "center", bordered: false });
  finishRow(ws, row, "fyHeader");
  applyGreyUnusedCols(ws, row, COL_G);
  row += 1;

  const ap = essential?.accountsPayables || {};
  const apRows = [
    "i) Accounts payable x 365 days",
    "ii) Cost of goods/services procured",
    "iii) Number of days of accounts payables",
  ];

  const rowNum = row;
  const rowDenom = row + 1;
  apRows.forEach((label, idx) => {
    setCell(ws, row, COL_D, label, { align: "left", bordered: false });
    if (idx < 2) {
      setCell(ws, row, COL_E, "", { align: "center", fill: VALUE_FILL, bordered: false });
      setCell(ws, row, COL_F, "", { align: "center", fill: VALUE_FILL, bordered: false });
      finishRow(ws, row, idx === 0 ? "apLabel" : "apFormula");
    } else {
      setCalcDataOrFormula(
        ws,
        row,
        COL_E,
        ap.currentFinancialYear,
        accountsPayablesFormula(COL_E, rowNum, rowDenom)
      );
      setCalcDataOrFormula(
        ws,
        row,
        COL_F,
        ap.previousFinancialYear,
        accountsPayablesFormula(COL_F, rowNum, rowDenom)
      );
      finishRow(ws, row, "apFormula");
    }
    applyGreyUnusedCols(ws, row, COL_G);
    row += 1;
  });

  return row;
}

function clearMergedSlaveFill(ws, row, col) {
  ws.getCell(row, col).fill = { type: "pattern", pattern: "none" };
}

function addOpennessHeader(ws, row, fyCurrent, fyPrevious) {
  setCell(ws, row, COL_D, "Parameter", { bold: true, align: "center", bordered: false });
  setCell(ws, row, COL_E, "Metrics", { bold: true, align: "center", bordered: false });
  setCell(ws, row, COL_F, fyCurrent, { bold: true, align: "center", bordered: false });
  setCell(ws, row, COL_G, fyPrevious, { bold: true, align: "center", bordered: false });
  finishRow(ws, row, "opennessHeader");
  applyGreyUnusedCols(ws, row);
  return row + 1;
}

function addOpennessDataRow(ws, row, parameter, metric, current, previous, borderPattern) {
  setCell(ws, row, COL_D, parameter, { align: "left", vertical: "top", bordered: false });
  setCell(ws, row, COL_E, metric, { align: "left", vertical: "top", bordered: false });
  setDataCell(ws, row, COL_F, current);
  setDataCell(ws, row, COL_G, previous);
  finishRow(ws, row, borderPattern);
  applyGreyUnusedCols(ws, row);
  if (!REF_ROW_HEIGHTS[row]) {
    setAutoRowHeight(ws, row, [{ text: metric, width: 30 }]);
  }
  return row + 1;
}

function addOpennessPctRow(ws, row, parameter, metric, currentVal, numRow, denomRow) {
  setCell(ws, row, COL_D, parameter, { align: "left", vertical: "top", bordered: false });
  setCell(ws, row, COL_E, metric, { align: "left", vertical: "top", bordered: false });
  setCalcDataOrFormula(ws, row, COL_F, currentVal.current, ratioFormula(COL_F, numRow, denomRow));
  setCalcDataOrFormula(ws, row, COL_G, currentVal.previous, ratioFormula(COL_G, numRow, denomRow));
  finishRow(ws, row, "opennessPct");
  applyGreyUnusedCols(ws, row);
  if (!REF_ROW_HEIGHTS[row]) {
    setAutoRowHeight(ws, row, [{ text: metric, width: 30 }]);
  }
  return row + 1;
}

function addOpennessTable(ws, row, essential, fyCurrent, fyPrevious) {
  finishRow(ws, row, "q9Intro", 30);
  mergeRow(ws, row, COL_D, COL_G, LABELS.q9, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "q9Intro",
  });
  applyGreyUnusedCols(ws, row);
  row += 1;

  const rpt = essential?.relatedPartyTransactions || {};
  row = addOpennessHeader(ws, row, fyCurrent, fyPrevious);

  const purchasesStart = row;
  const pNumRow = row;
  row = addOpennessDataRow(
    ws,
    row,
    "Concentration of Purchases",
    "a. i) Purchases from trading houses",
    "",
    "",
    "opennessFirst"
  );
  const pDenomRow = row;
  row = addOpennessDataRow(ws, row, "Concentration of Purchases", "ii) Total purchases", "", "", "opennessMid");
  row = addOpennessPctRow(
    ws,
    row,
    "Concentration of Purchases",
    "iii) Purchases from trading houses as % of total purchases",
    {
      current: rptValue(rpt, "concentrationOfPurchased", "purchasedFromTrading", "currentFinancialYear"),
      previous: rptValue(rpt, "concentrationOfPurchased", "purchasedFromTrading", "previousFinancialYear"),
    },
    pNumRow,
    pDenomRow
  );
  row = addOpennessDataRow(
    ws,
    row,
    "Concentration of Purchases",
    "b. Number of trading houses where purchases are made",
    rptValue(rpt, "concentrationOfPurchased", "purchasedAreMadeFrom", "currentFinancialYear"),
    rptValue(rpt, "concentrationOfPurchased", "purchasedAreMadeFrom", "previousFinancialYear"),
    "opennessB"
  );
  const pTopNumRow = row;
  row = addOpennessDataRow(
    ws,
    row,
    "Concentration of Purchases",
    "c. i) Purchases from top 10 trading houses",
    "",
    "",
    "opennessCFirst"
  );
  const pTopDenomRow = row;
  row = addOpennessDataRow(
    ws,
    row,
    "Concentration of Purchases",
    "ii) Total purchases from trading houses",
    "",
    "",
    "opennessMid"
  );
  row = addOpennessPctRow(
    ws,
    row,
    "Concentration of Purchases",
    "iii) Purchases from top 10 trading houses as % of total purchases from trading houses",
    {
      current: rptValue(rpt, "concentrationOfPurchased", "top10TradingHouse", "currentFinancialYear"),
      previous: rptValue(rpt, "concentrationOfPurchased", "top10TradingHouse", "previousFinancialYear"),
    },
    pTopNumRow,
    pTopDenomRow
  );
  ws.mergeCells(purchasesStart, COL_D, row - 1, COL_D);

  row = addOpennessHeader(ws, row, fyCurrent, fyPrevious);

  const salesStart = row;
  const sNumRow = row;
  row = addOpennessDataRow(
    ws,
    row,
    "Concentration of Sales",
    "a. i) Sales to dealer / distributors",
    "",
    "",
    "opennessFirst"
  );
  const sDenomRow = row;
  row = addOpennessDataRow(ws, row, "Concentration of Sales", "ii) Total Sales", "", "", "opennessMid");
  row = addOpennessPctRow(
    ws,
    row,
    "Concentration of Sales",
    "iii) Sales to dealer / distributors as % of total sales",
    {
      current: rptValue(rpt, "concentrationOfSales", "salesOfDealerDistributors", "currentFinancialYear"),
      previous: rptValue(rpt, "concentrationOfSales", "salesOfDealerDistributors", "previousFinancialYear"),
    },
    sNumRow,
    sDenomRow
  );
  row = addOpennessDataRow(
    ws,
    row,
    "Concentration of Sales",
    "b. Number of  dealers / distributors to whom sales are made",
    rptValue(rpt, "concentrationOfSales", "salesAreMade", "currentFinancialYear"),
    rptValue(rpt, "concentrationOfSales", "salesAreMade", "previousFinancialYear"),
    "opennessB"
  );
  const sTopNumRow = row;
  row = addOpennessDataRow(
    ws,
    row,
    "Concentration of Sales",
    "c. i) Sales to top 10 dealers / distributors",
    "",
    "",
    "opennessCFirst"
  );
  const sTopDenomRow = row;
  row = addOpennessDataRow(
    ws,
    row,
    "Concentration of Sales",
    "ii) Total Sales to dealer / distributors",
    "",
    "",
    "opennessMid"
  );
  row = addOpennessPctRow(
    ws,
    row,
    "Concentration of Sales",
    "iii) Sales to top 10 dealers / distributors as % of total sales to dealer / distributors",
    {
      current: rptValue(rpt, "concentrationOfSales", "top10dealers", "currentFinancialYear"),
      previous: rptValue(rpt, "concentrationOfSales", "top10dealers", "previousFinancialYear"),
    },
    sTopNumRow,
    sTopDenomRow
  );
  ws.mergeCells(salesStart, COL_D, row - 1, COL_D);

  row = addOpennessHeader(ws, row, fyCurrent, fyPrevious);

  const rptStart = row;
  const rptBlocks = [
    {
      letter: "a",
      label: "Purchases (Purchases with related parties)",
      total: "Total Purchases",
      pct: "Purchases (Purchases with related parties as % of Total Purchases)",
      key: "purchases",
    },
    {
      letter: "b",
      label: ". Sales (Sales to related parties)",
      total: "Total Sales",
      pct: "Sales (Sales to related parties as % of Total Sales)",
      key: "sales",
    },
    {
      letter: "c",
      label: "Loans & advances given to related parties",
      total: "Total loans & advances",
      pct: "Loans & advances given to related parties as % of Total loans & advances",
      key: "loans",
    },
    {
      letter: "d",
      label: "Investments in related parties",
      total: "Total Investments made",
      pct: "Investments in related parties as % of Total Investments made",
      key: "investments",
    },
  ];

  rptBlocks.forEach(({ letter, label, total, pct, key }) => {
    const numRow = row;
    row = addOpennessDataRow(ws, row, "Share of RPTs in", `${letter}. i) ${label}`, "", "", "opennessFirst");
    const denomRow = row;
    row = addOpennessDataRow(ws, row, "Share of RPTs in", `ii) ${total}`, "", "", "opennessMid");
    row = addOpennessPctRow(ws, row, "Share of RPTs in", `iii) ${pct}`, {
      current: rptValue(rpt, "shareOfRPTs", key, "currentFinancialYear"),
      previous: rptValue(rpt, "shareOfRPTs", key, "previousFinancialYear"),
    }, numRow, denomRow);
  });

  ws.mergeCells(rptStart, COL_D, row - 1, COL_D);
  return row;
}

export function buildPrinciple1Sheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet("PRINCIPLE 1");
  setupPrinciple1Sheet(ws);

  const principle = sectionC?.principle1 || {};
  const essential = principle?.essentialIndicators || {};
  const leadership = principle?.leadershipIndicator || {};
  const fyLabels = getFinancialYearLabels(reportingYear);
  const fyCurrent = fyLabels.currentYear
    ? `FY (${fyLabels.currentYear})`
    : "FY (Current Financial Year)";
  const fyPrevious = fyLabels.previousYear
    ? `PY (${fyLabels.previousYear})`
    : "PY (Previous Financial Year)";

  let row = FIRST_ROW;
  row = addSectionBand(ws, row, LABELS.sectionC);
  row = addFullWidthRow(ws, row, LABELS.intro, { borderPattern: "introRow", fixedHeight: true });
  ws.getRow(row - 1).height = 45;
  row = addPrincipleBand(ws, row, LABELS.principleTitle);
  row = addSubtitleBand(ws, row, LABELS.essential, "subtitleBand", { bold: true });

  row = addTrainingTable(ws, row, essential?.percentageCoverageByTraining || {});
  row = addFineRows(ws, row);

  finishRow(ws, row, "q3Row");
  mergeRow(ws, row, COL_D, COL_H, LABELS.q3, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "q3Row",
  });
  addDetailLink(ws, row, COL_I, APPEAL_OR_REVISION_CASE_SHEET, "D12");
  row += 1;

  finishRow(ws, row, "q4Row");
  mergeRow(ws, row, COL_D, COL_F, LABELS.q4, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "q4Row",
  });
  applyMergedLabelFills(ws, row, COL_E, COL_F);
  setDataCell(ws, row, COL_G, toYesNo(essential?.antiCorruptionPolicy?.hasPolicy));
  setGreyCell(ws, row, COL_H);
  setGreyCell(ws, row, COL_I);
  row += 1;

  finishRow(ws, row, "q4Details");
  mergeRow(ws, row, COL_D, COL_F, LABELS.q4Details, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "q4Details",
  });
  applyMergedLabelFills(ws, row, COL_E, COL_F);
  setCell(ws, row, COL_G, safeText(essential?.antiCorruptionPolicy?.policyDetails), {
    align: "left",
    vertical: "top",
    fill: VALUE_FILL,
    bordered: false,
  });
  applyGreyUnusedCols(ws, row, COL_H);
  row += 1;

  finishRow(ws, row, "q4Link");
  mergeRow(ws, row, COL_D, COL_F, LABELS.q4Link, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "q4Link",
  });
  const policyLink = essential?.antiCorruptionPolicy?.policyLink;
  if (policyLink) {
    setCell(ws, row, COL_G, policyLink, { align: "left", link: policyLink, fill: VALUE_FILL, bordered: false });
  } else {
    setCell(ws, row, COL_G, "", { align: "left", fill: VALUE_FILL, bordered: false });
  }
  applyGreyUnusedCols(ws, row, COL_H);
  row += 1;

  row = addDisciplinaryTable(ws, row, essential, fyCurrent, fyPrevious);
  row = addConflictTable(ws, row, essential, fyCurrent, fyPrevious);

  finishRow(ws, row, "q7Row", 29.25);
  mergeRow(ws, row, COL_D, COL_H, LABELS.q7, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "q7Row",
  });
  setCell(ws, row, COL_I, safeText(essential?.correctiveActions), {
    align: "left",
    vertical: "top",
    fill: VALUE_FILL,
    bordered: false,
  });
  row += 1;

  row = addAccountsPayablesTable(ws, row, essential, fyCurrent, fyPrevious);
  row = addOpennessTable(ws, row, essential, fyCurrent, fyPrevious);

  row = addSubtitleBand(ws, row, LABELS.leadership, "leadershipBand", { bold: true });

  finishRow(ws, row, "leadershipQ1");
  mergeRow(ws, row, COL_D, COL_G, LABELS.leadershipQ1, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "leadershipQ1",
  });
  addDetailLink(ws, row, COL_H, PROGRAMMES_FOR_VALUE_CHAIN_SHEET, "E12");
  setGreyCell(ws, row, COL_I);
  row += 1;

  finishRow(ws, row, "leadershipQ2");
  mergeRow(ws, row, COL_D, COL_G, LABELS.leadershipQ2, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "leadershipQ2",
  });
  setDataCell(ws, row, COL_H, toYesNo(leadership?.avoidManageConflict?.status));
  setGreyCell(ws, row, COL_I);
  row += 1;

  finishRow(ws, row, "leadershipDetails");
  mergeRow(ws, row, COL_D, COL_G, LABELS.leadershipQ2Details, {
    align: "left",
    vertical: "top",
    bordered: false,
    borderPattern: "leadershipDetails",
  });
  setCell(ws, row, COL_H, safeText(leadership?.avoidManageConflict?.remark), {
    align: "left",
    vertical: "top",
    fill: VALUE_FILL,
    bordered: false,
  });
  setGreyCell(ws, row, COL_I);
  row += 1;

  finishRow(ws, row, "notesRow", 33);
  setCell(ws, row, COL_D, LABELS.notes, { align: "left", bordered: false });
  mergeRow(ws, row, COL_F, COL_I, "", {
    align: "left",
    bordered: false,
    borderPattern: "notesRow",
  });
  applyGreyBandFill(ws, row, COL_F, COL_I);
  ws.getCell(row, COL_I).border = {
    top: THIN,
    bottom: MEDIUM,
    right: MEDIUM,
  };

  hideRowsThrough(ws, 5);
  return ws;
}
